const $body = $('body');

const detectIE = () => {
    var ua = window.navigator.userAgent;

    // ie10
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        $body.addClass('is-ie');
    }

    // ie11 +
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        $body.addClass('is-ie');
    }

    // Edge ie12+
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        $body.addClass('is-ie');
    }
}

const events = () => {
    detectIE();
}

const init = () => {
  events();
}

export default init;